<template>
  <footer class="site-footer">
    <div
      class="site-footer__shell"
    >
      <div class="site-footer__inner">
        <p class="site-footer__health">
          Pour votre santé, mangez au moins cinq fruits et légumes par jour.
        </p>
        <p class="site-footer__health">
          <a
            class="site-footer__mangerbouger"
            href="https://www.mangerbouger.fr"
            target="_blank"
            rel="noopener noreferrer"
          >
            www.mangerbouger.fr
          </a>
        </p>

        <nav class="site-footer__nav" aria-label="Liens de pied de page">
          <ul class="site-footer__nav-list">
            <li
              v-for="(item, index) in footerLinks"
              :key="item.to || item.href"
              class="site-footer__nav-item"
            >
              <a
                v-if="item.external"
                class="site-footer__nav-link"
                :href="item.href"
                target="_blank"
                rel="noopener noreferrer"
              >
                {{ item.label }}
              </a>
              <router-link
                v-else
                class="site-footer__nav-link"
                :to="item.to"
              >
                {{ item.label }}
              </router-link>
              <span
                v-if="index < footerLinks.length - 1"
                class="site-footer__nav-sep"
                aria-hidden="true"
              />
            </li>
            <!-- OneTrust cookies settings button start -->
            <li class="site-footer__nav-item">
              <span class="site-footer__nav-sep" aria-hidden="true" />
              <button id="ot-sdk-btn" class="ot-sdk-show-settings site-footer__cookie-btn">
                Gestion des cookies
              </button>
            </li>
            <!-- OneTrust cookies settings button end -->
          </ul>
        </nav>

        <p class="site-footer__copyright">
          © Ferrero 2026. Tous droits réservés
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
import {
  REGLEMENT_JEU_PDF_URL,
  MENTIONS_LEGALES_URL,
  POLITIQUE_CONFIDENTIALITE_URL,
} from "@/constants/reglement";

export default {
  name: "FooterView",
  data() {
    return {
      footerLinks: [
        {
          href: POLITIQUE_CONFIDENTIALITE_URL,
          label: "Politique de confidentialité",
          external: true,
        },
        {
          href: REGLEMENT_JEU_PDF_URL,
          label: "Règlement",
          external: true,
        },
        {
          href: MENTIONS_LEGALES_URL,
          label: "Mentions légales",
          external: true,
        },
        { to: "/contact", label: "Contact" },
        { to: "/", label: "Accueil" },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.site-footer {
  margin-top: auto;
  width: 100%;
}

.site-footer__shell {
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  box-sizing: border-box;
  background-color: #672e12;
  color: #fff;
}

.site-footer__inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1.75rem 1rem 2rem;
  text-align: center;
  gap: 1rem;
}

.site-footer__health {
  margin: 0;
  color: #fff;
  text-align: center;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  max-width: 42rem;
}

.site-footer__mangerbouger {
  color: #fff;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: auto;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
}

.site-footer__mangerbouger:hover,
.site-footer__mangerbouger:focus-visible {
  color: #fff;
}

.site-footer__nav {
  padding-top: 0.25rem;
}

.site-footer__nav-list {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 0.5rem 0.75rem;
  margin: 0;
  padding: 0;
  list-style: none;
}

.site-footer__nav-item {
  display: inline-flex;
  align-items: center;
  gap: 0.75rem;
}

.site-footer__nav-sep {
  display: inline-block;
  width: 1px;
  height: 18px;
  flex-shrink: 0;
  opacity: 0.25;
  background: #d9d9d9;
}

.site-footer__nav-link {
  color: var(--Blanc, #fff);
  text-align: center;
  font-family: "Intro Demo", "Arial Black", "Helvetica Neue", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 900;
  line-height: 16px;
  text-decoration: none;
}

.site-footer__nav-link:hover,
.site-footer__nav-link:focus-visible {
  text-decoration: underline;
  text-underline-offset: 0.15em;
}

.site-footer__copyright {
  margin: 0.5rem 0 0;
  color: var(--Blanc, #fff);
  text-align: center;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
}


/* ≤360px : liens de navigation centrés, un par ligne (maquette mobile) */
@media (max-width: 360px) {
  .site-footer__inner {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .site-footer__nav-list {
    flex-direction: column;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: center;
    gap: 1.5rem;
  }

  .site-footer__nav-item {
    display: block;
    text-align: center;
  }

  .site-footer__nav-sep {
    display: none;
  }

  .site-footer__nav-link {
    text-transform: uppercase;
  }
}
</style>

<!-- OneTrust injecte ses propres styles sur #ot-sdk-btn : bloc non-scoped requis -->
<style lang="scss">
.site-footer #ot-sdk-btn.ot-sdk-show-settings.site-footer__cookie-btn {
  background: none !important;
  border: none !important;
  padding: 0 !important;
  margin: 0 !important;
  min-width: 0 !important;
  box-shadow: none !important;
  cursor: pointer;
  color: var(--Blanc, #fff) !important;
  text-align: center;
  font-family: "Intro Demo", "Arial Black", "Helvetica Neue", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 900;
  line-height: 16px;
  text-decoration: none !important;
  text-transform: none;
  opacity: 1 !important;
}

.site-footer #ot-sdk-btn.ot-sdk-show-settings.site-footer__cookie-btn:hover,
.site-footer #ot-sdk-btn.ot-sdk-show-settings.site-footer__cookie-btn:focus-visible {
  background: none !important;
  color: var(--Blanc, #fff) !important;
  text-decoration: underline !important;
  text-underline-offset: 0.15em;
  opacity: 1 !important;
}
</style>
